import { themeOptionFactory as mobile } from "./mobile"

export const themeOptionFactories = {
  mobile,
  "kiosk-h": null,
  "kiosk-v": null,
}
